import { create } from 'zustand'
import { persist, createJSONStorage } from 'zustand/middleware'
import { tokenStore } from '@/lib/api/client'
import type { ApiUser, LoginResult } from '../model/types'

interface AuthState {
  user: ApiUser | null
  isAuthed: boolean
  setSession: (result: LoginResult) => void
  setUser: (u: ApiUser | null) => void
  logout: () => void
}

export const useApiAuth = create<AuthState>()(
  persist(
    (set) => ({
      user: null,
      isAuthed: false,
      setSession: (result) => {
        tokenStore.set(result.accessToken, result.refreshToken)
        set({ user: result.user, isAuthed: true })
      },
      setUser: (user) => set({ user, isAuthed: !!user }),
      logout: () => {
        tokenStore.clear()
        set({ user: null, isAuthed: false })
      },
    }),
    {
      name: 'xedien.apiAuth.v1',
      storage: createJSONStorage(() => localStorage),
      partialize: (s) => ({ user: s.user, isAuthed: s.isAuthed }),
    },
  ),
)
